import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgEnergyArrow = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 31"
    ref={ref}
    {...props}
  >
    <path
      fill="#FF4406"
      stroke="#FF4406"
      strokeWidth={2}
      d="M13.158 16.25 2.249 27.159a2.25 2.25 0 1 0 3.183 3.183L17.93 17.843a2.25 2.25 0 0 0 0-3.184L5.432 2.161a2.25 2.25 0 0 0-3.183 3.183z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgEnergyArrow);
export default ForwardRef;
